import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {StateProvider} from "./components/context/StateProvider";
import './scss/style.scss'

// Inicializar Eruda (consola de desarrollo para móvil)
// - Desarrollo: siempre activo
// - Producción: activar con ?debug=true, desactivar con ?debug=false
const urlParams = new URLSearchParams(window.location.search);
const debugParam = urlParams.get('debug');
const isDebugInStorage = localStorage.getItem('eruda') === 'true';

// Manejar activación/desactivación por URL
if (debugParam === 'true') {
    localStorage.setItem('eruda', 'true');
    console.log('[Eruda] Activado y guardado en localStorage');
} else if (debugParam === 'false') {
    localStorage.removeItem('eruda');
    console.log('[Eruda] Desactivado. Recarga para aplicar cambios.');
}

// Inicializar Eruda si está activo
const shouldInitEruda = process.env.NODE_ENV !== 'production' ||
                        isDebugInStorage ||
                        debugParam === 'true';

if (shouldInitEruda) {
    import('eruda').then(eruda => {
        eruda.default.init();
        console.log('[Eruda] Consola de desarrollo activa');
        console.log('[Eruda] Para desactivar: visita la URL con ?debug=false');
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <StateProvider>
        <App />
    </StateProvider>
);

// Registrar Service Worker para PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
